import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import { useSelector } from 'react-redux'

import { formatDate } from 'utils/utils.js'
import server from 'server/serverController2'
import constants from 'utils/constants'
import Presenter from 'components/presenters/task/AchivementBlock'
export default function AchivementBlock({ userNo, reloadData, setReloadData }) {
  const displayStickerNum = 3
  const [stickerList, setStickerList] = useState([])
  const [totalAuthDayCount, setTotalAuthDayCount] = useState(0)
  const loadData = () => {
    let queryString = qs.stringify({
      group_by: 'day',
      date_ge: formatDate(),
      date_le: formatDate(),
    })
    server.getRequestData(`users/${userNo}/stickers/collections?${queryString}`, (res) => {
      if (res.success !== 1) {
        return
      }
      const jsonData = res.data
      const collectionList = jsonData.collections
      setStickerList(collectionList)
    })

    server.getRequestData(`users/${userNo}`, (res) => {
      if (res.success !== 1) {
        return
      }
      const jsonData = res.data
      const userData = jsonData['user']
      if (userData?.total_auth_day_count) {
        setTotalAuthDayCount(() => userData?.total_auth_day_count?.total_count)
      }
    })
  }
  useEffect(() => {
    if (userNo) {
      loadData()
    }
  }, [])

  useEffect(() => {
    if (userNo && reloadData === true) {
      loadData()
      if (setReloadData) {
        setReloadData(false)
      }
    }
  }, [reloadData])

  return (
    <Presenter
      totalAuthDayCount={totalAuthDayCount}
      stickerList={stickerList}
      displayStickerNum={displayStickerNum}
    />
  )
}
